module.exports = __webpack_public_path__ + "static/Affiches-BRIDGE-72ppp-3-380-768b2aac11d07bb21cf37d702ce11d64.png";